<template>
  <div>
    <a-modal
      title="门店位置"
      :visible='mapvisibel'
      @cancel="mapvisibel = false"
      :footer="null"
      :maskClosable="true"
      :keyboard="true"
      destroyOnClose
      centered
      :width="800"
    >
      <div id="Mcontainer" style="width:100%;height:60vh"></div>
    </a-modal>

  </div>
</template>

<script>
export default {
  data () {
    return {
      mapvisibel: false
    };
  },

  created () {

  },
  methods: {
    show (mapLng, mapLat) {
      this.mapvisibel = true;
      AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
        this.map = new AMap.Map('Mcontainer', {
          resizeEnable: true,
          scrollWheel: true
        });
        this.map.setZoomAndCenter(15, [mapLng, mapLat]);

        let marker = new AMap.Marker({
          position: new AMap.LngLat(mapLng, mapLat),
          anchor: 'bottom-center',
          offset: new AMap.Pixel(0, 0)
        });
        this.map.add(marker);
      });
    }
  }
};
</script>
